import { ComponentProps } from 'react';
import { bordColorTheme } from 'styles/styles.constants';

const BordQuotationIcon = (props: ComponentProps<'svg'>) => {
  const { stroke } = props;

  return (
    <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M5.94708 0.732422V2.62904C5.94708 2.75479 5.99703 2.87539 6.08595 2.96432C6.17487 3.05324 6.29548 3.10319 6.42123 3.10319H8.31785" />
      <path
        d="M7.36954 9.2672H2.628C2.37649 9.2672 2.13528 9.16729 1.95744 8.98944C1.7796 8.8116 1.67969 8.5704 1.67969 8.31889V1.68073C1.67969 1.42922 1.7796 1.18802 1.95744 1.01017C2.13528 0.832333 2.37649 0.732422 2.628 0.732422H5.94708L8.31785 3.10319V8.31889C8.31785 8.5704 8.21794 8.8116 8.04009 8.98944C7.86225 9.16729 7.62105 9.2672 7.36954 9.2672Z"
        fill="white"
      />
      <path
        d="M5.94708 0.732422V2.62904C5.94708 2.75479 5.99703 2.87539 6.08595 2.96432C6.17487 3.05324 6.29548 3.10319 6.42123 3.10319H8.31785M8.31785 3.10319L5.94708 0.732422H2.628C2.37649 0.732422 2.13528 0.832333 1.95744 1.01017C1.7796 1.18802 1.67969 1.42922 1.67969 1.68073V8.31889C1.67969 8.5704 1.7796 8.8116 1.95744 8.98944C2.13528 9.16729 2.37649 9.2672 2.628 9.2672H7.36954C7.62105 9.2672 7.86225 9.16729 8.04009 8.98944C8.21794 8.8116 8.31785 8.5704 8.31785 8.31889V3.10319Z"
        stroke={stroke || bordColorTheme.navyBlue[400]}
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M5.9513 4.52591H4.76592C4.57729 4.52591 4.39638 4.60085 4.263 4.73423C4.12962 4.86761 4.05469 5.04851 4.05469 5.23714C4.05469 5.42577 4.12962 5.60668 4.263 5.74006C4.39638 5.87344 4.57729 5.94837 4.76592 5.94837H5.24007C5.4287 5.94837 5.60961 6.02331 5.74299 6.15669C5.87637 6.29007 5.9513 6.47098 5.9513 6.65961C5.9513 6.84824 5.87637 7.02914 5.74299 7.16252C5.60961 7.2959 5.4287 7.37084 5.24007 7.37084H4.05469M5.003 7.37084V7.84499M5.003 4.05176V4.52591"
        stroke={stroke || bordColorTheme.navyBlue[400]}
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export default BordQuotationIcon;
